const isAllChecked = form => !Object.values(form).some(checked => checked !== true);

export default isAllChecked;